const Wallet = () => {
	return (
		<div>
			<button>test</button>
		</div>
	);
};

export default Wallet;
